import * as React from "react";
import { cn } from "@/lib/utils";

const buttonVariants = {
  default: "bg-orange-500 text-white hover:bg-orange-600",
  outline: "border border-gray-200 bg-white hover:bg-gray-100",
  ghost: "hover:bg-gray-100",
};

const Button = React.forwardRef(
  (
    {
      className,
      variant = "default",
      size = "default",
      asChild = false,
      ...props
    },
    ref
  ) => {
    const baseStyles =
      "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";

    const sizeStyles = {
      default: "h-10 px-4 py-2",
      sm: "h-9 px-3",
      lg: "h-11 px-8",
      icon: "h-10 w-10",
    };

    const Comp = asChild ? React.Fragment : "button";

    return (
      <Comp
        className={cn(
          baseStyles,
          buttonVariants[variant],
          sizeStyles[size],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
